import { render, staticRenderFns } from "./AddonsFormTaxTable.vue?vue&type=template&id=d797969c&"
import script from "./AddonsFormTaxTable.vue?vue&type=script&lang=js&"
export * from "./AddonsFormTaxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports